import {
  Avatar,
  Button,
  ButtonGroup,
  Grid,
  GridList,
  makeStyles,
  Table,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import Axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import PieChart from "../PieChart";
import VisitorsByStatusBarchart from "../VisitorsByStatusBarChart";
const useStyles = makeStyles((theme) => ({
  input: {
    color: "#5A9BB7",
    fontFamily: "'Poppins', sansSerif",
    fontSize: "9px",
    fontWeight: "300",
  },
  textFieldRoot: {
    color: "#fff",
    backgroundColor: "#172941",
    alignItems: "center",
    padding: "0.5vw",
  },
  listContainer: {
    boxShadow:
      "12px 9px 16px 0 rgba(0, 0, 0, 0.15), -3px -3px 8px 0 rgba(255, 255, 255, 0.10)",
    padding: "1vw",
  },
  countContainer: {
    boxShadow:
      "12px 9px 16px 0 rgba(0, 0, 0, 0.15), -3px -3px 8px 0 rgba(255, 255, 255, 0.10)",
    borderRadius: "5px",
    height: "18vh",
    padding: "1vw",
  },

  tableContainer: {
    boxShadow:
      "12px 9px 16px 0 rgba(0, 0, 0, 0.15), -3px -3px 8px 0 rgba(255, 255, 255, 0.10)",
    borderRadius: "5px",
    // height: "12vh",
    padding: ".3vw",
  },
  tableHead: {
    fontWeight: "400",
    fontFamily: "'Poppins', sansSerif",
    fontSize: "10px",
  },
  text: {
    fontFamily: "'Poppins', sansSerif",
    color: "#5A9BB7",
    fontWeight: "500",
    fontSize: "16px",
  },
  text2: {
    fontFamily: "'Poppins', sansSerif",
    fontWeight: "600",
    fontSize: "3vw",
  },
  gridlist: {
    "&::-webkit-scrollbar": {
      width: "3px",
    },
  },
}));
export default function QueueSelected(props) {
  const classes = useStyles();

  const [list, setList] = useState([]);
  const [totalVisitors, setTotalVisitors] = useState(0);
  const [totalStanding, setTotalStanding] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingPichartData, setLoadingPichartData] = useState(false);

  const [totalEntered, setTotalEntered] = useState(0);
  const [totalExited, setTotalExited] = useState(0);
  const [entryOnTime, setEntryOnTime] = useState(0);
  const [late, setLate] = useState(0);
  const [notVisited, setNotVisited] = useState(0);

  const [users, setUsers] = useState([]);
  const [msg, setMsg] = useState([]);
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));

  const handleDateChange = (e) => {
    // console.log(e.target.value);
    // console.log(date);
    setDate(e.target.value);
    // getListOfUsers()
  };

  const { choosedQueueDetails } = props;
  const getListOfUsers = () => {
    setLoadingPichartData(true);
    setLoading(true);
    // console.log("getListOfUsers called");
    setMsg("");
    setUsers([]);
    setList([]);
    // console.log(
    //   "choosedQueueDetails : ",
    //   choosedQueueDetails.id,
    //   "and date",
    //   date
    // );
    Axios.post("https://asia-east2-apnaq-prod.cloudfunctions.net/getListOfUsersApi", {
      queueId: choosedQueueDetails.id,
      date: date,
    }).then((response) => {
      setLoading(false);

      if (response.data.success) {
        // console.log("list response ", response.data);
        // console.log("success");
        setList(response.data.queueData);
        setUsers(response.data.Report);
        //   setQueueFiveDaysSnapshotData(response.data.queueFiveDaysSnapshotData);
        getTotalEexited(response.data.Report);
        getTotalEntered(response.data.Report);
        getTotalVisitors(response.data.Report);
        getTotalStandings(response.data.Report);
        getPichartData(response.data.Report);
      } else {
        setMsg("No queue present on this date for this queue");
        // console.log("failed");
      }
    });
  };

  const getPichartData = async (user) => {
    var notVisited = 0;
    var late = 0;
    var onTime = 0;
    const filtered = user.filter((user) => user.isEntryScan === false);
    if (filtered.length === 0) {
      setNotVisited(0);
    } else {
      for (var i = 0; i < filtered.length; i++) {
        notVisited = notVisited + filtered[i].covisitors + 1;
        if (i === filtered.length - 1) {
          setNotVisited(notVisited);
        }
      }
    }

    // return standings

    const entryScanFiltered = user.filter((user) => user.isEntryScan === true);
    if (entryScanFiltered.length === 0) {
      console.log("entryScanFiltered length zero");
      setLoadingPichartData(false);
      setEntryOnTime(0);
    } else {
      for (var j = 0; j < entryScanFiltered.length; j++) {
        if (
          moment(entryScanFiltered[j].entryTime, "h:mm a").isBefore(
            moment(entryScanFiltered[j].timeAlloted, "h:mm a")
          )
        ) {
          onTime = onTime + entryScanFiltered[j].covisitors + 1;
        }

        if (j === entryScanFiltered.length - 1) {
          setEntryOnTime(onTime);
          setLoadingPichartData(false);
        }
      }
    }

    if (user.length === 0) {
      setLate(0);
      console.log("user length zero");
    } else {
      console.log("entered to late()");
      for (var k = 0; k < user.length; k++) {
        // console.log(moment(user[k].timeAlloted, "h:mm a").isBefore(moment()));
        if (user[k].entryTime) {
          console.log("has entry time");
          if (
            moment(user[k].timeAlloted, "h:mm a").isBefore(
              moment(user[k].entryTime, "h:mm a")
            )
          ) {
            late = late + user[k].covisitors + 1;
            if (k === user.length - 1) {
              setLate(late);
            }
          }
        } else if (moment(user[k].timeAlloted, "h:mm a").isBefore(moment())) {
          console.log("has no entry time and he is late");
          late = late + user[k].covisitors + 1;
          if (k === user.length - 1) {
            setLate(late);
          }
        } else {
          if (k === user.length - 1) {
            setLate(late);
          }
          console.log("not late");
        }

        // if (users[k].entryTime) {
        //   if (
        //     moment(users[k].timeAlloted, "h:mm a").isBefore(
        //       moment(users[k].entryTime, "h:mm a")
        //     )
        //   ) {
        //     late = late + users[k].covisitors + 1;
        //   }
        // } else {
        //   if (moment().isBefore(moment(users[k].timeAlloted, "h:mm a"))) {
        //     late = late + users[k].covisitors + 1;
        //   }
        // }
      }
    }
  };
  const getTotalVisitors = async (user) => {
    // console.log("getTotalVisitors called");
    var visitors = 0;
    for (var i = 0; i < user.length; i++) {
      visitors = visitors + user[i].covisitors + 1;
    }
    setTotalVisitors(visitors);
  };
  const getTotalStandings = async (user) => {
    var standings = 0;
    const filtered = user.filter(
      (user) => user.isEntryScan === true && user.isExited === false
    );
    for (var i = 0; i < filtered.length; i++) {
      standings = standings + filtered[i].covisitors + 1;
    }
    // return standings
    setTotalStanding(standings);
  };
  const getTotalEntered = async (user) => {
    var entered = 0;
    const filtered = user.filter((user) => user.isEntryScan === true);
    for (var i = 0; i < filtered.length; i++) {
      entered = entered + filtered[i].covisitors + 1;
    }
    // return entered
    setTotalEntered(entered);
  };
  const getTotalEexited = async (user) => {
    var exited = 0;
    const filtered = user.filter((user) => user.isExited === true);
    for (var i = 0; i < filtered.length; i++) {
      exited = exited + filtered[i].covisitors + 1;
    }
    // return exited
    setTotalExited(exited);
  };
  useEffect(() => {
    if (choosedQueueDetails) {
      setTotalExited(0);
      setTotalEntered(0);
      setTotalVisitors(0);
      setTotalStanding(0);
      setLate(0);
      setNotVisited(0);
      setEntryOnTime(0);
      getListOfUsers();
    }
  }, [choosedQueueDetails, date]);

  // const reportWithoutContacts =() =>{
  //    returnusers.map(user=>{
  //     return {
  //       sl:user.sl,
  //       slot:user.slotNumber,
  //       name:user.name,
  //       phone:user.phone,
  //       covisitors:user.covisitors,
  //     }
  //   })
  // }

  var headers = [
    { label: "sl", key: "sl" },
    { label: "Slot", key: "slotNumber" },
    { label: "Name", key: "name" },
    { label: "Alloted Time", key: "timeAlloted" },
    { label: "Covisitors", key: "covisitors" },
    { label: "Entry time", key: "entryTime" },
    { label: "Exit time", key: "exitTime" },
  ];
  return (
    <Grid container spacing={3}>
      {/* <Grid container lg={6}>
        <Grid container item lg={12} direction="column" spacing={3}> */}
      <Grid container item lg={6}>
        <Grid container className={classes.listContainer}>
          <Grid container lg={4}>
            <Typography
              style={{
                fontSize: "16px",
                fontFamily: "'Poppins', sansSerif",
                fontWeight: "500",
                color: "#5A9BB7",
              }}
            >
              Total
            </Typography>
            {"  "}
            <Typography
              style={{
                fontSize: "16px",
                fontFamily: "'Poppins', sansSerif",
                fontWeight: "500",
                color: "#21E19A",
                marginLeft: "10px",
              }}
            >
              {totalVisitors}
            </Typography>
            <Grid container style={{ padding: "0px" }}>
              <Typography
                style={{
                  fontSize: "16px",
                  fontFamily: "'Poppins', sansSerif",
                  fontWeight: "500",
                  color: "#5A9BB7",
                }}
              >
                Visitors
              </Typography>
            </Grid>
          </Grid>
          <Grid container lg={8} direction="row-reverse">
            <ButtonGroup
              variant="contained"
              style={{
                boxShadow:
                  "12px 9px 16px 0 rgba(0, 0, 0, 0.15), -3px -3px 8px 0 rgba(255, 255, 255, 0.10)",
              }}
              component="div"
            >
              <TextField
                id="date"
                type="date"
                defaultValue={new Date().toISOString().slice(0, 10)}
                variant="standard"
                InputLabelProps={
                  {
                    // shrink: true,
                  }
                }
                classes={{ root: classes.textFieldRoot }}
                InputProps={{
                  className: classes.input,
                  disableUnderline: true,

                  // endAdornment:<TodayIcon />
                  // endAdornment: (
                  //   <InputAdornment position={'start'}>
                  //     <Icon>
                  //     <TodayIcon />
                  //     </Icon>
                  //   </InputAdornment>)
                }}
                onChange={handleDateChange}
              />
              {users.length > 0 ? (
                //   <Select
                //   labelId="demo-simple-select-label"
                //   id="demo-simple-select"
                //   value={age}
                //   onChange={handleChange}
                // >
                //   <MenuItem value={1}>DOWNLOAD</MenuItem>
                //   <MenuItem value={20}>Twenty</MenuItem>
                //   <MenuItem value={30}>Thirty</MenuItem>
                // </Select>
                <Button
                  disableElevation
                  style={{ backgroundColor: "#132740", color: "#fff" }}
                >
                  <CSVLink
                    data={users}
                    headers={headers}
                    style={{
                      color: "#22FCA8",
                      fontSize: "9px",
                      fontFamily: "'Poppins', sansSerif",
                      fontWeight: "300",
                      textDecoration: "none",
                    }}
                  >
                    {" "}
                    Download Report{" "}
                    <FontAwesomeIcon
                      icon={faDownload}
                      className={classes.icon}
                    />
                  </CSVLink>
                </Button>
              ) : null}
            </ButtonGroup>
          </Grid>
          <Grid container>
            <GridList
              style={{ height: "50vh", width: "40vw", padding: "1vw" }}
              className={classes.gridList}
            >
              <Table style={{ width: "100%" }}>
                {users.length > 0
                  ? users.map((user) => (
                      <TableRow>
                        <Grid container spacing={3} alignContent="flex-start">
                          <Grid item lg={2}>
                            <Grid
                              container
                              // className={classes.tableContainer}
                              justify="center"
                            >
                              <Avatar
                                src={user.photoUrl}
                                alt=""
                                variant="square"
                                style={{
                                  height: "2.2vw",
                                  width: "2.5vw",
                                  borderRadius: "5px",
                                  boxShadow:
                                    "12px 9px 16px 0 rgba(0, 0, 0, 0.15), -5px -5px 8px 0 rgba(255, 255, 255, 0.10)",
                                }}
                              />
                            </Grid>
                          </Grid>
                          <Grid item lg={2}>
                            <Grid
                              container
                              className={classes.tableContainer}
                              justify="center"
                            >
                              <Typography
                                style={{
                                  color: "#BDC5E0",
                                  fontWeight: "400",
                                  fontFamily: "'Poppins', sansSerif",
                                  fontSize: "12px",
                                }}
                              >
                                {user.slotNumber}
                              </Typography>
                              <Grid container justify="center">
                                <Typography
                                  style={{
                                    color: "#BDC5E0",
                                    fontWeight: "400",
                                    fontFamily: "'Poppins', sansSerif",
                                    fontSize: "8px",
                                  }}
                                >
                                  {user.timeAlloted}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item lg={8}>
                            <Grid container className={classes.tableContainer}>
                              <Grid container>
                                <Grid item lg={4}>
                                  <Typography
                                    style={{
                                      color: "#BDC5E0",
                                    }}
                                    className={classes.tableHead}
                                  >
                                    ENTRY AT
                                  </Typography>
                                  <Grid container>
                                    <Typography
                                      style={{
                                        color: "#22FCA8",
                                      }}
                                      className={classes.tableHead}
                                    >
                                      {user.entryTime ? (
                                        user.entryTime
                                      ) : (
                                        <>--:--</>
                                      )}
                                    </Typography>
                                  </Grid>
                                </Grid>
                                <Grid item lg={4}>
                                  <Typography
                                    className={classes.tableHead}
                                    style={{ color: "#BDC5E0" }}
                                  >
                                    {user.name.slice(0, 18).toUpperCase()}
                                  </Typography>
                                  <Grid container>
                                    {user.isExited ? (
                                      <Typography
                                        style={{ color: "#FF4183" }}
                                        className={classes.tableHead}
                                      >
                                        OUTSIDE
                                      </Typography>
                                    ) : user.isEntryScan ? (
                                      <Typography
                                        style={{ color: "#22FCA8" }}
                                        className={classes.tableHead}
                                      >
                                        ENTERED
                                      </Typography>
                                    ) : (
                                      <Typography
                                        style={{ color: "#22FCA8" }}
                                        className={classes.tableHead}
                                      >
                                        INSIDE
                                      </Typography>
                                    )}
                                  </Grid>
                                </Grid>
                                <Grid item lg={4}>
                                  <Typography
                                    style={{ color: "#BDC5E0" }}
                                    className={classes.tableHead}
                                  >
                                    EXIT AT
                                  </Typography>
                                  <Grid container>
                                    <Typography
                                      style={{ color: "#FF4183" }}
                                      className={classes.tableHead}
                                    >
                                      {user.exitTime ? (
                                        user.exitTime
                                      ) : (
                                        <>--:--</>
                                      )}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        {/* <
                  {filt.mapValue.fields.isEntryScan.booleanValue ? (
                    <FontAwesomeIcon
                      icon={faSignInAlt}
                      className={classes.icon}
                      style={{ color: "green" }}
                    />
                  ) : null}
                  {filt.mapValue.fields.isExited.booleanValue ? (
                    <FontAwesomeIcon
                      icon={faSignOutAlt}
                      className={classes.icon}
                      style={{ color: "red" }}
                    />
                  ) : null}
                </ */}
                      </TableRow>
                    ))
                  : null}
              </Table>
            </GridList>
          </Grid>
        </Grid>
      </Grid>
      <Grid container item lg={6} spacing={3}>
        <Grid item container lg={6}>
          <Grid
            container
            className={classes.countContainer}
            alignItems="center"
          >
            <Grid container>
              <Typography className={classes.text}>Total</Typography>
            </Grid>
            <Grid container>
              <Typography className={classes.text}> joined</Typography>
            </Grid>
            <Grid container>
              <Typography
                style={{
                  color: "#5ADFFE",
                }}
                className={classes.text2}
              >
                {users.length}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item container lg={6}>
          <Grid
            container
            className={classes.countContainer}
            alignItems="center"
          >
            <Grid container>
              <Typography className={classes.text}>Total</Typography>
            </Grid>
            <Grid container>
              <Typography className={classes.text}> visitors</Typography>
            </Grid>
            <Grid container>
              <Typography
                style={{
                  color: "#22FCA8",
                }}
                className={classes.text2}
              >
                {totalVisitors}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item container lg={6}>
          <Grid
            container
            className={classes.countContainer}
            alignItems="center"
          >
            <Grid container>
              <Typography className={classes.text}>Total</Typography>
            </Grid>
            <Grid container>
              <Typography className={classes.text}> standings</Typography>
            </Grid>
            <Grid container>
              <Typography
                style={{
                  color: "#FD95C9",
                }}
                className={classes.text2}
              >
                {totalStanding}{" "}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item container lg={6}>
          <Grid
            container
            className={classes.countContainer}
            alignItems="center"
          >
            <Grid container>
              <Typography className={classes.text}>Total</Typography>
            </Grid>
            <Grid container>
              <Typography className={classes.text}> entered</Typography>
            </Grid>{" "}
            <Grid container>
              <Typography
                className={classes.text2}
                style={{
                  color: "#5F96FF",
                }}
              >
                {totalEntered}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item container lg={6}>
          <Grid
            container
            className={classes.countContainer}
            alignItems="center"
          >
            <Grid container>
              <Typography className={classes.text}>Total</Typography>
            </Grid>
            <Grid container>
              <Typography className={classes.text}> exited</Typography>
            </Grid>{" "}
            <Grid container>
              <Typography
                className={classes.text2}
                style={{
                  color: "#FF4183",
                }}
              >
                {totalExited}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item container lg={6}>
          <Grid
            container
            className={classes.countContainer}
            alignItems="center"
          >
            <Grid container>
              <Typography className={classes.text}>Service</Typography>
            </Grid>
            <Grid container>
              <Typography className={classes.text}> time</Typography>
            </Grid>
            <Grid container>
              <Typography
                className={classes.text2}
                style={{
                  color: "#A06EFF",
                }}
              >
                {list.serviceTime ? (
                  <>
                    {list.serviceTime}
                    <Typography
                      className={classes.text2}
                      style={{
                        color: "#A06EFF",
                        fontSize: "40px",
                        display: "inline",
                      }}
                    >
                      min
                    </Typography>{" "}
                  </>
                ) : (
                  <>
                    0
                    <Typography
                      className={classes.text2}
                      style={{
                        color: "#A06EFF",
                        fontSize: "40px",
                        display: "inline",
                      }}
                    >
                      min
                    </Typography>
                  </>
                )}
                {/* not calculated */}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container item lg={6}>
        <Grid container className={classes.listContainer}>
          <Typography className={classes.text}>User</Typography>
          <Grid container>
            <Typography className={classes.text}>Activity</Typography>
          </Grid>
          <Grid container>
            {users.length > 0 ? (
                <PieChart
                  // entryOnTime={entryOnTime}
                  // late={late}
                  // notVisited={notVisited}
                  statusData={users}
                  // data={[0,0,5]}

                  loadingPichartData={loadingPichartData}
                />
            ) : (
              <>Nothing to show</>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid container item lg={6}>
        <Grid
          container
          className={classes.listContainer}
          style={{ marginRight: "1vw" }}
        >
          <Typography className={classes.text}>Visitors</Typography>
          <Grid container>
            <Typography className={classes.text}>By Status</Typography>
          </Grid>
          <Grid container>
            {users.length > 0 ? (
              <VisitorsByStatusBarchart statusData={users} />
            ) : (
              <>Nothing to show</>
            )}
          </Grid>
        </Grid>
      </Grid>
      {/* </Grid>
      </Grid> */}
    </Grid>
  );
}
